// frontend/src/api/authService.ts
import axios from 'axios';
import { type TokenResponse } from '@/types/authTypes';

// Get the base URL for the API from environment variables
const API_BASE_URL = import.meta.env.VITE_API_BASE_URL;

// Create an axios instance for making API requests
const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

/**
 * Sends a login request to the backend.
 * @param email - The user's email address.
 * @param password - The user's password.
 * @returns A promise that resolves to the API response.
 */
export const loginUser = (email: string, password: string) => {
  // The backend's OAuth2PasswordRequestForm expects data in a specific format
  // (application/x-www-form-urlencoded), not JSON. URLSearchParams creates this format.
  const formData = new URLSearchParams();
  formData.append('username', email); // The form expects the email as 'username'
  formData.append('password', password);

  return apiClient.post<TokenResponse>('/auth/login', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};
